/*
 * File: index.ts
 * Author: Austin Robinson
 * Date Created: 5/26/2023
 * Copyright (c) DrivingDoc 2023
 */
import { createQuery } from 'react-query-kit';

import { MinimalUser, PostGreSQLInterval, privateApi } from 'api';

import { AttendanceValue } from './TakeAttendance';

export interface GetCoursePeriodParams {
  id: string;
}

// export type CoursePeriod = {
//   tenant_id: string;
//   id: string;
//   course_section_id: string;
//   start: string;
//   end: string;
//   open_enrollment: string | null;
//   close_enrollment: string | null;
//   capacity: number | null;
//   deleted: boolean;
//   created_at: string | null;
//   updated_at: string | null;
//   created_by_user: MinimalUser | null;
//   updated_by_user: MinimalUser | null;
//   course_period_instructors: {
//     instructor_user_id: string;
//     instructor: {
//       tenant_id: string;
//       user_id: string;
//       calendar_color: string | null;
//       created_at: string | null;
//       updated_at: string | null;
//       user: MinimalUser;
//     };
//   }[];
//   period_enrollments: {
//     tenant_id: string;
//     student_user_id: string;
//     course_period_id: string;
//     course_enrollment_id: string;
//     attendance: string | null;
//     attendance_taken_at: string | null;
//     attendance_taken_by_user: MinimalUser | null;
//     absence_fee: string | null;
//     no_permit_fee: string | null;
//     canceled_at: string | null;
//     canceled_by_user: MinimalUser | null;
//     cancellation_fee: string | null;
//     late_cancellation_fee: string | null;
//     notes: string | null;
//     private_notes: string | null;
//     created_by: string | null;
//     created_at: string | null;
//     performance_time_earned: PostGreSQLInterval | null;
//     observation_time_earned: PostGreSQLInterval | null;
//     enrollment_type: 'performance_and_observation' | 'observation_only';

//     student: {
//       tenant_id: string;
//       user_id: string;
//       permit_num: string | null;
//       permit_issued: string | null;
//       permit_expiration: string | null;
//       permit_restrictions: string | null;
//       permit_endorsements: string | null;
//       permit_created_at: string | null;
//       permit_updated_at: string | null;
//       medical_conditions: string | null;
//       high_school: string | null;
//       user: {
//         tenant_id: string;
//         id: string;
//         title: string | null;
//         first_name: string | null;
//         middle_name: string | null;
//         last_name: string | null;
//         nickname: string | null;
//         email: string | null;
//         date_of_birth: string | null;
//         sex: string | null;
//         active: boolean;
//         created_at: string | null;
//         updated_at: string | null;
//         created_by: string | null;
//         updated_by: string | null;
//         des_id: string | null;
//         user_addresses: {
//           tenant_id: string;
//           user_id: string;
//           priority: number;
//           name: string | null;
//           street_address: string | null;
//           apt_no: string | null;
//           po_box_no: string | null;
//           city: string | null;
//           state: string | null;
//           zip: string | null;
//           country: string | null;
//         }[];
//         user_phones: {
//           tenant_id: string;
//           user_id: string;
//           priority: number;
//           name: string | null;
//           type: string;
//           phone: string;
//           extension: string | null;
//         }[];
//       };
//       parents: {
//         tenant_id: string;
//         student_user_id: string;
//         first_name: string;
//         last_name: string;
//         relation: string | null;
//         email: string | null;
//         cell_phone: string | null;
//         home_phone: string | null;
//         work_phone: string | null;
//         work_extension: string | null;
//       }[];
//       period_enrollments: {
//         tenant_id: string;
//         student_user_id: string;
//         course_period_id: string;
//         course_enrollment_id: string;
//         attendance: string | null;
//         attendance_taken_at: string | null;
//         attendance_taken_by: string | null;
//         absence_fee: string | null;
//         no_permit_fee: string | null;
//         canceled_at: string | null;
//         canceled_by: string | null;
//         cancellation_fee: string | null;
//         late_cancellation_fee: string | null;
//         late_cancel_override: boolean | null;
//         notes: string | null;
//         private_notes: string | null;
//         created_by: string | null;
//         course_period: {
//           tenant_id: string;
//           id: string;
//           course_section_id: string;
//           start: string;
//           end: string;
//           open_enrollment: string | null;
//           close_enrollment: string | null;
//           capacity: number | null;
//           deleted: boolean;
//         };
//       }[];
//     };
//   }[];
//   course_section: {
//     tenant_id: string;
//     id: string;
//     course_id: string;
//     title: string;
//     description: string | null;
//     open_enrollment: string | null;
//     close_enrollment: string | null;
//     capacity: number;
//     tenant_location_id: string | null;
//     course: {
//       tenant_id: string;
//       id: string;
//       course_type: 'behind_the_wheel' | 'in_person' | 'synchronous_online' | 'fully_online';
//       schedule_type: 'self_scheduled' | 'fixed' | 'manual' | 'no_schedule';
//       title: string;
//       description: string | null;
//       created_at: string | null;
//       created_by: string | null;
//       updated_at: string | null;
//       updated_by: string | null;
//     };
//   };
//   course_period_waiting_list: {
//     student: {
//       tenant_id: string;
//       user_id: string;
//       permit_num: string | null;
//       permit_issued: string | null;
//       permit_expiration: string | null;
//       permit_restrictions: string | null;
//       permit_endorsements: string | null;
//       permit_created_at: string | null;
//       permit_updated_at: string | null;
//       medical_conditions: string | null;
//       high_school: string | null;
//       user: MinimalUser;
//     };
//   }[];
// };

export type CoursePeriod = {
  tenant_id: string;
  id: string;
  course_section_id: string;
  start: string;
  end: string;
  open_enrollment: string | null;
  close_enrollment: string | null;
  capacity: number | null;
  deleted: boolean;
  created_at: string | null;
  updated_at: string | null;
  created_by_user: MinimalUser | null;
  updated_by_user: MinimalUser | null;
  course_section: {
    tenant_id: string;
    id: string;
    course_id: string;
    title: string;
    description: string | null;
    open_enrollment: string | null;
    close_enrollment: string | null;
    capacity: number;
    tenant_location_id: string | null;
    course: {
      tenant_id: string;
      id: string;
      course_type: 'behind_the_wheel' | 'in_person' | 'synchronous_online' | 'fully_online';
      schedule_type: 'self_scheduled' | 'fixed' | 'manual' | 'no_schedule';
      title: string;
      description: string | null;
      created_at: string | null;
      created_by: string | null;
      updated_at: string | null;
      updated_by: string | null;
    };
  };
  course_period_instructors: {
    instructor_user_id: string;
    instructor: {
      tenant_id: string;
      user_id: string;
      calendar_color: string | null;
      created_at: string | null;
      updated_at: string | null;
      user: MinimalUser;
    };
  }[];
  period_enrollments: {
    tenant_id: string;
    student_user_id: string;
    course_period_id: string;
    course_enrollment_id: string;
    attendance: AttendanceValue;
    attendance_taken_at: string | null;
    attendance_taken_by_user: MinimalUser | null;
    absence_fee: string | null;
    no_permit_fee: string | null;
    canceled_at: string | null;
    canceled_by_user: MinimalUser | null;
    cancellation_fee: string | null;
    late_cancellation_fee: string | null;
    notes?: object | null;
    notes_updated_at?: string | null;
    notes_updated_by?: string | null;
    notes_updated_by_user: MinimalUser | null;
    private_notes?: object | null;
    private_notes_updated_at?: string | null;
    private_notes_updated_by?: string | null;
    private_notes_updated_by_user: MinimalUser | null;
    created_by: string | null;
    created_at: string | null;
    performance_time_earned: PostGreSQLInterval | null;
    observation_time_earned: PostGreSQLInterval | null;
    enrollment_type: 'performance_and_observation' | 'observation_only';
    period_number: string; // integer

    student: {
      tenant_id: string;
      user_id: string;
      permit_num: string | null;
      permit_issued: string | null;
      permit_expiration: string | null;
      permit_restrictions: string | null;
      permit_endorsements: string | null;
      permit_created_at: string | null;
      permit_updated_at: string | null;
      medical_conditions: string | null;
      high_school: string | null;
      user: MinimalUser;
    };
  }[];
};

async function getCoursePeriod(params: GetCoursePeriodParams | undefined) {
  if (params === undefined) {
    return null;
  }

  // Set the API endpoint URL
  const result = await privateApi.get<CoursePeriod>(
    `${import.meta.env.VITE_API_BASE_URL}/courses/periods/${params?.id}`,
    {},
  );

  // return the data object
  return result.data;
}

const useGetCoursePeriod = createQuery<CoursePeriod | null, GetCoursePeriodParams, Error>({
  queryKey: ['course_period'],
  fetcher: (variables) => getCoursePeriod(variables),
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  enabled: (data) => !data,
});

export { getCoursePeriod, useGetCoursePeriod };
